<template>
  <div>
    <v-app-bar app color="#711610" dark>
      <template v-if="$vuetify.breakpoint.smAndDown">
        <v-app-bar-nav-icon
          @click.stop="menuVisible = !menuVisible"
        ></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
      </template>
      <template>
        <v-toolbar-title justify-end>
          <v-btn text>{{ getBarTitle }}</v-btn>
        </v-toolbar-title>
      </template>
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            text
            :color="toolbarItem == index ? 'white' : ''"
            v-for="(item, index) in listMenu"
            :key="index"
            :to="item.url"
            >{{ item.name }}</v-btn
          >
        </v-toolbar-items>
      </template>
      <template>
        <v-spacer></v-spacer>
        <v-menu
          v-if="$vuetify.breakpoint.mdAndUp"
          bottom
          offset-y
          origin="center center"
          :nudge-bottom="10"
          transition="slide-y-transition"
          max-width="250px"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" class="mx-2">
              <v-avatar>
                <img
                  :src="
                    getUserInfo.fotoPerfil
                      ? getUserInfo.fotoPerfil
                      : getStaticProfile
                  "
                />
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <v-list-item justify-end>
              <v-list-item-avatar tile>
                <v-icon large color="bolsa-guinda"
                  >mdi-card-account-details</v-icon
                >
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  >{{ getUserInfo.nombres }} {{ getUserInfo.apellidoPaterno }}
                  {{ getUserInfo.apellidoMaterno }}</v-list-item-title
                >
                <v-list-item-subtitle v-if="getUserInfo.carrera">
                  {{ getUserInfo.carrera.nombreEspecialidad }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item :to="{ name: 'Perfil' }">
              <v-list-item-action>
                <v-icon>mdi-account-tie</v-icon>
              </v-list-item-action>
              <v-list-item-title>Ver Perfil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-action>
                <v-icon>mdi-power-standby</v-icon>
              </v-list-item-action>
              <v-list-item-title>Cerrar Sesión</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>

    <home-drawer v-model="menuVisible" :items="listMenu" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'HomeAppBar',

  components: {
    HomeDrawer: () => import('./Drawer')
  },

  data: function () {
    return {
      menuVisible: false,
      toolbarItem: 0,
      listMenu: [
        {
          name: 'Alumni',
          url: '/usuario/trabajos',
          icon: 'mdi-briefcase'
        },
        {
          name: 'Publicaciones',
          url: '/usuario/publicaciones',
          icon: 'mdi-clipboard-text-search'
        },
        {
          name: 'Test UNI',
          url: '/usuario/prueba',
          icon: 'mdi-test-tube'
        }
      ]
    };
  },

  computed: {
    getBarTitle () {
      let title = this.listMenu.find((i) => i.to === this.$route.path);

      return !title
        ? this.$route.name
          ? this.$route.name
          : 'App'
        : title.name;
    },

    getStaticProfile () {
      return require('@/assets/anonymous.png');
    },

    ...mapGetters('user', ['getUserInfo', 'getError', 'fetching'])
  },

  methods: {
    ...mapActions('auth', ['logout']),

    ...mapActions('user', [
      'getProfileInfo',
      'fetchUbicationData',
      'getCarreras',
      'fetchIndustrias',
      'fetchResultadosGlobalesTest',
      'fetchStateTest'
    ])
  },

  async mounted () {
    await this.getProfileInfo();
    await this.fetchUbicationData();
    await this.getCarreras();
    await this.fetchIndustrias();
    await this.fetchResultadosGlobalesTest();
    await this.fetchStateTest();
  }
};
</script>
